import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["clipboardIcon", "clipboardLabel"]

  showFeedback() {
    this.clipboardIconTarget.classList.remove("tw-text-gray-800")
    this.clipboardIconTarget.classList.add("tw-text-green-500")
    this.clipboardLabelTarget.classList.remove("tw-text-gray-800")
    this.clipboardLabelTarget.classList.add("tw-text-green-500")
    this.clipboardLabelTarget.innerText = "Copiado"
  }
}
